import routes from '@modules/property-setting/property-setting-routes';
import store from '@modules/property-setting/property-setting-store';

export default {
  routes,
  store,
};
